import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const TenantsList = Loadable(lazy(() => import('views/tenants/TenantsList')));
const TenantCreation = Loadable(lazy(() => import('views/tenants/TenantCreation')));
const InstancesList = Loadable(lazy(() => import('views/instances/InstancesList')));
const InstanceCreation = Loadable(lazy(() => import('views/instances/InstanceCreation')));
const ParksList = Loadable(lazy(() => import('views/parks/ParksList')));
const ParkCreation = Loadable(lazy(() => import('views/parks/ParkCreation')));
const ParkDetails = Loadable(lazy(() => import('views/parks/ParkDetails')));
const ClientsList = Loadable(lazy(() => import('views/clients/ClientsList')));
const ClientCreation = Loadable(lazy(() => import('views/clients/ClientCreation')));
const SentOrders = Loadable(lazy(() => import('views/orders/SentOrders')));
const SentOrderDetails = Loadable(lazy(() => import('views/orders/SentOrderDetails')));
const TradedVolumes = Loadable(lazy(() => import('views/orders/TradedVolumes')));
const OpenPositions = Loadable(lazy(() => import('views/orders/OpenPositions')));
const AuditEventsList = Loadable(lazy(() => import('views/audit/AuditEventsList')));
const AuditEventDetails = Loadable(lazy(() => import('views/audit/AuditEventDetails')));

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <Navigate to="/tenants" replace />
    },
    {
      path: '/tenants',
      element: <TenantsList />
    },
    {
      path: '/tenants/create',
      element: <TenantCreation />
    },
    {
      path: '/instances',
      element: <InstancesList />
    },
    {
      path: '/instances/create',
      element: <InstanceCreation />
    },
    {
      path: '/parks',
      element: <ParksList />
    },
    {
      path: '/parks/create',
      element: <ParkCreation />
    },
    {
      path: '/parks/:id',
      element: <ParkDetails />
    },
    {
      path: '/clients',
      element: <ClientsList />
    },
    {
      path: '/clients/create',
      element: <ClientCreation />
    },
    {
      path: '/orders/sent',
      element: <SentOrders />
    },
    {
      // park scope + client order id, so the page is deep-linkable
      path: '/orders/sent/:instance/:parkId/:clientOrderId',
      element: <SentOrderDetails />
    },
    {
      path: '/orders/traded-volumes',
      element: <TradedVolumes />
    },
    {
      path: '/orders/open-positions',
      element: <OpenPositions />
    },
    {
      path: '/orders/audit-events',
      element: <AuditEventsList />
    },
    {
      path: '/orders/audit-events/:eventId',
      element: <AuditEventDetails />
    }
  ]
};

export default MainRoutes;
